import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/fp/debounce';
import find from 'lodash/fp/find';
import t from '@instructure/quiz-i18n/es/format-message';
import { Spinner } from '@instructure/ui-spinner';
import TagWrapper from '../../../common/components/shared/TagWrapper';
import { SHARED_WITH_USER, SHARED_WITH_COURSE, SHARED_WITH_ACCOUNT, SELECT_EMPTY_OPTION, Select } from '@instructure/quiz-common';
export var AsyncSearch = /*#__PURE__*/function (_Component) {
  function AsyncSearch() {
    var _this;
    _classCallCheck(this, AsyncSearch);
    _this = _callSuper(this, AsyncSearch, arguments);
    _defineProperty(_this, "setInputRef", function (inputRef) {
      _this.inputRef = inputRef;
    });
    _defineProperty(_this, "state", {
      inputValue: '',
      isShowingOptions: false,
      isLoading: false,
      highlightedOptionId: null,
      shareableSubaccounts: [],
      shareableCourses: [],
      shareableUsers: []
    });
    _defineProperty(_this, "handleShowOptions", function () {
      _this.setState({
        isShowingOptions: true
      });
    });
    _defineProperty(_this, "handleHideOptions", function () {
      var allOptions = [].concat(_toConsumableArray(_this.filterOptions(_this.state.shareableSubaccounts)), _toConsumableArray(_this.filterOptions(_this.state.shareableCourses)), _toConsumableArray(_this.filterOptions(_this.state.shareableUsers)));

      // an option matching user input exists
      if (allOptions.length === 1) {
        var onlyOption = allOptions[0];
        // automatically select the matching option
        var label = onlyOption.label || onlyOption.fullName || onlyOption.title || onlyOption.name;
        if (label && label.toLowerCase() === _this.state.inputValue.toLowerCase()) {
          _this.changeSelectedOption([].concat(_toConsumableArray(_this.props.selectedOption.map(function (option) {
            return option.uuid;
          })), [onlyOption.uuid]));
        }
      }
      _this.setState({
        isShowingOptions: false,
        highlightedOptionId: null,
        shareableCourses: [],
        shareableUsers: [],
        inputValue: ''
      });
    });
    _defineProperty(_this, "handleBlur", function () {
      _this.setState({
        highlightedOptionId: null
      });
    });
    _defineProperty(_this, "handleHighlightOption", function (event, _ref) {
      var id = _ref.id;
      event.persist();
      var option = _this.getOptionById(id);
      if (!option) return;
      _this.setState({
        highlightedOptionId: id,
        inputValue: event.type === 'keydown' ? option.fullName || option.title : _this.state.inputValue
      });
    });
    _defineProperty(_this, "changeSelectedOption", function (optionIds) {
      _this.props.onSelectionChange(optionIds.map(function (id) {
        return _this.getOptionById(id);
      }));
    });
    _defineProperty(_this, "handleSelectOption", function (event, _ref2) {
      var id = _ref2.id;
      if (!id || id === SELECT_EMPTY_OPTION) return;
      _this.changeSelectedOption([].concat(_toConsumableArray(_this.props.selectedOption.map(function (option) {
        return option.uuid;
      })), [id]));
      _this.setState({
        inputValue: '',
        isShowingOptions: false
      });
    });
    _defineProperty(_this, "handleInputChange", function (event) {
      var value = event.target.value;
      var longEnough = value && value.length >= _this.props.minChars;
      var common = {
        inputValue: value,
        isShowingOptions: true,
        shareableCourses: [],
        shareableUsers: []
      };
      if (!!value && longEnough) {
        _this.setState(_objectSpread(_objectSpread({}, common), {}, {
          isLoading: true,
          highlightedOptionId: null
        }));
        _this.search(value);
      } else {
        _this.setState(_objectSpread(_objectSpread({}, common), {}, {
          isLoading: false
        }));
      }
    });
    _defineProperty(_this, "handleKeyDown", function (event) {
      var inputValue = _this.state.inputValue;
      if (event.keyCode === 8) {
        // when backspace key is pressed
        if (inputValue === '' && _this.props.selectedOption.length > 0) {
          // remove last selected option, if input has no entered text
          _this.changeSelectedOption(_this.props.selectedOption.slice(0, -1).map(function (option) {
            return option.uuid;
          }));
          _this.setState({
            highlightedOptionId: null
          });
        }
      }
    });
    _defineProperty(_this, "dismissTag", function (id) {
      _this.changeSelectedOption(_this.props.selectedOption.filter(function (option) {
        return option.uuid !== id;
      }).map(function (option) {
        return option.uuid;
      }));
      _this.setState({
        highlightedOptionId: null
      }, function () {
        _this.inputRef.focus();
      });
    });
    _this.search = debounce(_this.props.debounceDelay, function (value) {
      var shouldSearchPeople = !_this.props.searchType || _this.props.searchType === SHARED_WITH_USER;
      var shouldSearchCourses = !_this.props.searchType || _this.props.searchType === SHARED_WITH_COURSE;
      var shouldSearchSubaccounts = _this.props.searchType === SHARED_WITH_ACCOUNT;
      // TODO add the promise cancellation for avoiding having disordered requests
      if (shouldSearchPeople) {
        _this.props.getShareableUsers(value).then(function (shareableUsers) {
          var filteredUsers = _this.filterOptions(shareableUsers);
          _this.setState({
            shareableUsers: shareableUsers,
            highlightedOptionId: filteredUsers.length ? filteredUsers[0].uuid : _this.state.highlightedOptionId,
            isLoading: false
          });
        });
      }
      if (shouldSearchCourses) {
        _this.props.getShareableCourses(value).then(function (shareableCourses) {
          var filteredCourses = _this.filterOptions(shareableCourses);
          _this.setState({
            shareableCourses: shareableCourses,
            highlightedOptionId: _this.state.highlightedOptionId ? _this.state.highlightedOptionId : filteredCourses.length ? filteredCourses[0].uuid : null,
            isLoading: false
          });
        });
      }
      if (shouldSearchSubaccounts) {
        _this.props.getShareableSubaccounts(value).then(function (shareableSubaccounts) {
          var filteredAccounts = _this.filterOptions(shareableSubaccounts);
          _this.setState({
            shareableSubaccounts: shareableSubaccounts,
            highlightedOptionId: filteredAccounts.length ? filteredAccounts[0].uuid : _this.state.highlightedOptionId,
            isLoading: false
          });
        });
      }
    });
    return _this;
  }
  _inherits(AsyncSearch, _Component);
  return _createClass(AsyncSearch, [{
    key: "getOptionById",
    value: function getOptionById(id) {
      var user = find({
        uuid: id
      }, this.state.shareableUsers);
      if (user) {
        return _objectSpread(_objectSpread({}, user), {}, {
          entityType: SHARED_WITH_USER
        });
      }
      var course = find({
        uuid: id
      }, this.state.shareableCourses);
      if (course) {
        return _objectSpread(_objectSpread({}, course), {}, {
          entityType: SHARED_WITH_COURSE
        });
      }
      var account = find({
        uuid: id
      }, this.state.shareableSubaccounts);
      if (account) {
        return _objectSpread(_objectSpread({}, account), {}, {
          entityType: SHARED_WITH_ACCOUNT
        });
      }
      return find({
        uuid: id
      }, this.props.selectedOption);
    }
  }, {
    key: "renderTags",
    value: function renderTags() {
      var _this2 = this;
      return this.props.selectedOption.map(function (option, index) {
        return /*#__PURE__*/React.createElement(TagWrapper, {
          key: option.uuid,
          id: option.uuid,
          index: index,
          text: option.fullName || option.title || option.name,
          onClick: _this2.dismissTag
        });
      });
    }
  }, {
    key: "filterOptions",
    value: function filterOptions(options) {
      var _this3 = this;
      return this.props.selectionFilter(options).filter(function (option) {
        return !_this3.props.selectedOption.some(function (selected) {
          return selected.uuid === option.uuid;
        });
      });
    }
  }, {
    key: "renderPeopleOptions",
    value: function renderPeopleOptions(people) {
      var _this4 = this;
      return /*#__PURE__*/React.createElement(Select.Group, {
        key: SHARED_WITH_USER,
        renderLabel: t('People')
      }, people.map(function (person) {
        return /*#__PURE__*/React.createElement(Select.Option, {
          "data-automation": "sdk-item-bank-option-user-".concat(person.uuid),
          id: person.uuid,
          key: person.uuid,
          isHighlighted: person.uuid === _this4.state.highlightedOptionId
        }, person.fullName);
      }));
    }
  }, {
    key: "renderCoursesOptions",
    value: function renderCoursesOptions(courses) {
      var _this5 = this;
      return /*#__PURE__*/React.createElement(Select.Group, {
        key: SHARED_WITH_COURSE,
        renderLabel: t('Courses')
      }, courses.map(function (course) {
        return /*#__PURE__*/React.createElement(Select.Option, {
          "data-automation": "sdk-item-bank-option-course-".concat(course.uuid),
          id: course.uuid,
          key: course.uuid,
          isHighlighted: course.uuid === _this5.state.highlightedOptionId
        }, course.title);
      }));
    }
  }, {
    key: "renderSubaccountsOptions",
    value: function renderSubaccountsOptions(subaccounts) {
      var _this6 = this;
      return /*#__PURE__*/React.createElement(Select.Group, {
        key: SHARED_WITH_ACCOUNT,
        renderLabel: t('Accounts')
      }, subaccounts.map(function (subaccount) {
        return /*#__PURE__*/React.createElement(Select.Option, {
          "data-automation": "sdk-item-bank-option-subaccount-".concat(subaccount.uuid),
          id: subaccount.uuid,
          key: subaccount.uuid,
          isHighlighted: subaccount.uuid === _this6.state.highlightedOptionId
        }, subaccount.name);
      }));
    }
  }, {
    key: "emptyOption",
    value: function emptyOption() {
      var minCharsMessage = t('Search term must be at least { minChars } characters', {
        minChars: this.props.minChars
      });
      if (this.props.minChars > 1 && this.state.inputValue < this.props.minChars) {
        return minCharsMessage;
      }
      return this.state.inputValue === '' ? t('Write to search') : t('No Results');
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var groups = [];
      var people = this.filterOptions(this.state.shareableUsers);
      if (people.length) {
        groups.push(this.renderPeopleOptions(people));
      }
      var courses = this.filterOptions(this.state.shareableCourses);
      if (courses.length) {
        groups.push(this.renderCoursesOptions(courses));
      }
      var subaccounts = this.filterOptions(this.state.shareableSubaccounts);
      if (subaccounts.length) {
        groups.push(this.renderSubaccountsOptions(subaccounts));
      }
      return groups.length ? groups : /*#__PURE__*/React.createElement(Select.Option, {
        id: SELECT_EMPTY_OPTION,
        key: SELECT_EMPTY_OPTION
      }, this.state.isLoading ? /*#__PURE__*/React.createElement(Spinner, {
        renderTitle: t('Loading'),
        size: "x-small"
      }) : this.emptyOption());
    }
  }, {
    key: "placeholder",
    value: function placeholder() {
      if (this.props.placeholderLabel) {
        return this.props.placeholderLabel;
      }
      if (this.props.searchType === SHARED_WITH_ACCOUNT) {
        return t('Enter subaccount name');
      } else if (this.props.searchType === SHARED_WITH_COURSE) {
        return t('Enter course name or course id');
      } else {
        return t('Enter name or login id');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        inputValue = _this$state.inputValue,
        isShowingOptions = _this$state.isShowingOptions;
      return /*#__PURE__*/React.createElement(Select, {
        "data-automation": "sdk-item-bank-share-input",
        renderLabel: this.props.searchLabel,
        placeholder: this.placeholder(),
        inputValue: inputValue,
        isShowingOptions: isShowingOptions,
        inputRef: this.setInputRef,
        onBlur: this.handleBlur,
        onInputChange: this.handleInputChange,
        onRequestShowOptions: this.handleShowOptions,
        onRequestHideOptions: this.handleHideOptions,
        onRequestHighlightOption: this.handleHighlightOption,
        onRequestSelectOption: this.handleSelectOption,
        renderBeforeInput: this.props.selectedOption.length > 0 ? this.renderTags() : null,
        onKeyDown: this.handleKeyDown
      }, this.renderOptions());
    }
  }]);
}(Component);
_defineProperty(AsyncSearch, "propTypes", {
  debounceDelay: PropTypes.number,
  minChars: PropTypes.number,
  onSelectionChange: PropTypes.func.isRequired,
  getShareableCourses: PropTypes.func,
  getShareableUsers: PropTypes.func,
  getShareableSubaccounts: PropTypes.func,
  searchType: PropTypes.string,
  selectedOption: PropTypes.arrayOf(PropTypes.shape({
    avatar: PropTypes.string,
    fullName: PropTypes.string,
    title: PropTypes.string,
    uuid: PropTypes.string.isRequired
  })).isRequired,
  selectionFilter: PropTypes.func,
  searchLabel: PropTypes.string,
  placeholderLabel: PropTypes.string
});
_defineProperty(AsyncSearch, "defaultProps", {
  debounceDelay: 500,
  minChars: 1,
  searchType: null,
  selectionFilter: function selectionFilter(value) {
    return value;
  },
  getShareableCourses: null,
  getShareableUsers: null,
  getShareableSubaccounts: null,
  searchLabel: t('Share With'),
  placeholder: null
});
export default AsyncSearch;